import { ThemeType } from '@app/api/models/Theme';
import styled from 'lib/styled';
import React from 'react';
import { FC } from 'react';
import { colors } from '../../Shared/Style/colors';
import { ReactComponent as Icon } from '../pin-3.svg';

const ThemedLocationPin = styled(Icon)(({ theme }: { theme: ThemeType }) => {
    return {
        height: '24px',
        width: '24px',
        '& g': {
            stroke: theme?.colors?.icons || colors.icons,
        },
    };
});
const LocationPin: FC = ({ ...rest }) => {
    return <ThemedLocationPin {...rest} />;
};

export default LocationPin;
